import ButtonExternal from '@teetsh/app/src/components/Buttons/ExternalLink';
import ButtonLink from '@teetsh/app/src/components/Buttons/Link';
import { Menu } from '@teetsh/app/src/components/Menu';
import { MenuItem } from '@teetsh/app/src/containers/Header/menus';
import React from 'react';
import { useTranslation } from 'react-i18next';
import 'twin.macro';

interface Props {
  items: MenuItem[];
}

export function MenuItems({ items }: Props) {
  const { t } = useTranslation(['common']);

  return (
    <span>
      {items.map(item => (
        <Menu.Item key={item.title}>
          {item.isExternal ? (
            <ButtonExternal
              tw="whitespace-nowrap rounded-none font-normal"
              key={item.title}
              href={item.route}
              large
              minimal
              fill
              alignText="left"
              icon={item.icon as any}
            >
              {t(`common:userProfileMenu.${item.title}`)}
            </ButtonExternal>
          ) : (
            <ButtonLink
              tw="whitespace-nowrap rounded-none font-normal"
              aria-label={`menu profile ${item.title}`}
              key={item.title}
              to={item.route}
              minimal
              fill
              alignText="left"
              large
              icon={item.icon as any}
            >
              {t(`common:userProfileMenu.${item.title}`)}
            </ButtonLink>
          )}
        </Menu.Item>
      ))}
    </span>
  );
}
